import React from 'react';
import { FontWeight, Heading, Text } from '@lili/lili-frontend-common';

interface AppointAdminTermsProps {
  administratorName: string;
  administratorEmail: string;
  primaryOwnerName: string;
  businessName: string;
}

const textClassName = 'text-text-main-primary text-left';

export const ListItem = ({ text }: { text: string }) => (
  <div className='flex flex-row gap-[12px]'>
    <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
      •
    </Text.H9>
    <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
      {text}
    </Text.H9>
  </div>
);
export const AppointAdminTerms = ({
  administratorName,
  administratorEmail,
  primaryOwnerName,
  businessName,
}: AppointAdminTermsProps) => (
  <div className='flex flex-col items-start gap-[20px]'>
    <Heading.H9 fontWeight={FontWeight.SEMIBOLD} className={textClassName}>
      Add an Administrator to Your Account
    </Heading.H9>
    <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
      This Authorization allows you to give another person, such as an office manager, bookkeeper or other employee
      (“Administrator”) full access to your account information with transaction authority. The Administrator will have
      the ability to deposit and withdraw funds by ACH, wire, or check. Given the sensitive nature of the information
      you will be sharing with the Administrator, as well as the ability to move funds into and out of the account, you
      should carefully consider whether to grant Administrator access. It should only be given to someone you employ and
      trust. Moreover, you should monitor the account activity carefully to ensure that the activity is consistent with
      the interests of the company.
    </Text.H9>
    <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
      Please read the following important information before providing us with information about the Administrator:
    </Text.H9>

    <div className='flex flex-col  px-[24px]'>
      <ListItem text='The Administrator will be able to review, print, download, and save your account information, including but not limited to your tax information, balances, transactions, statements, invoices, and other non-public information such as your date of birth, social security number and mailing address;' />
      <ListItem text='The Administrator will have access to the company’s account until you terminate his or her access or until you close the account;' />
      <ListItem text='The Administrator will have the ability to conduct transactions, move money into or out of your account, or change the account settings.' />
    </div>
    <div className='flex flex-col items-start gap-[20px]  px-[24px]  '>
      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        By signing this Administrator Authorization, I hereby authorize Lili App Inc. (Lili) and Sunrise Banks, N.A.,
        Member FDIC (Sunrise) to provide the person named below (“Administrator”) access to this Lili account. I consent
        to and authorize Lili to give my Administrator the ability to review, print, download, save, and distribute
        account data, including statements, transaction history, and account profile information.
      </Text.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        I understand that by granting full account access to the Administrator, he or she will have access to personal
        information contained in my account, including my Social Security number, account number, mailing address,
        telephone number, and email address, as well as such non-public personally identifiable information about each
        and every Authorized User. I also understand that the Administrator will have the ability to move funds into and
        out of the account, just as any Authorized User.
      </Text.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        {'By checking the box below, I direct and provide consent to Lili to share my non-public personally identifiable information with the Administrator.\n' +
          'I agree that I will indemnify and hold harmless Lili and Sunrise from any and all matters arising from this Authorization and that Lili and Sunrise are not responsible in any way for any damages that may arise from my granting Account Access to the individual below.\n' +
          'I understand that the Administrator will have full control of the Company\'s ' +
          'Lili Account and that the individual could withdraw all funds from the Account without my knowledge once such Authorization is granted.'}
      </Text.H9>

      <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
        I hereby certify that I have authority on behalf of the Company to grant Administrator access to this account.
      </Text.H9>

      <div className='flex flex-col'>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          {`Name of Administrator: ${administratorName}`}
        </Text.H9>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          {`Email Address of Administrator: ${administratorEmail}`}
        </Text.H9>
      </div>
      <div className='flex flex-col'>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          {primaryOwnerName}
        </Text.H9>
        <Text.H9 fontWeight={FontWeight.REGULAR} className={textClassName}>
          {businessName}
        </Text.H9>
      </div>
    </div>
  </div>
);
